import { useRouter } from "next/router"
import { useRef, useEffect } from "react"

export default function UTMTracker() {
  const router = useRouter()
  const trackedRef = useRef(false)

  useEffect(() => {
    if (trackedRef.current) return

    const {
      utm_source,
      utm_campaign,
      utm_medium,
      utm_content,
      utm_term,
      // Google Ads
      gclid,
      gbraid,
      wbraid,
      gad_source,
      gad_campaignid,
      // Facebook/Meta Ads
      fbclid,
      campaign_id,
      fbadid,
      // TikTok Ads
      ttclid,
      tt_campaign_id,
      // Microsoft/Bing Ads
      msclkid,
      campaignid,
      CampaignId,
      // Twitter/X Ads
      twclid,
      twcamp,
      // LinkedIn Ads
      li_campaign_id,
    } = router.query

    const hasTracking =
      utm_source ||
      utm_campaign ||
      gclid ||
      gbraid ||
      gad_source ||
      fbclid ||
      campaign_id ||
      ttclid ||
      tt_campaign_id ||
      msclkid ||
      campaignid ||
      twclid ||
      twcamp ||
      li_campaign_id

    if (hasTracking) {
      let source = utm_source as string
      if (!source) {
        if (gclid) source = "google"
        else if (fbclid) source = "facebook"
        else if (ttclid) source = "tiktok"
        else if (msclkid) source = "bing"
        else if (twclid) source = "twitter"
      }

      let detectedCampaignId = null
      if (gad_campaignid) detectedCampaignId = gad_campaignid
      else if (campaign_id) detectedCampaignId = campaign_id
      else if (fbadid) detectedCampaignId = fbadid
      else if (tt_campaign_id) detectedCampaignId = tt_campaign_id
      else if (campaignid || CampaignId) detectedCampaignId = campaignid || CampaignId
      else if (twcamp) detectedCampaignId = twcamp
      else if (li_campaign_id) detectedCampaignId = li_campaign_id

      const data = {
        utm_source: source || null,
        utm_campaign: utm_campaign || null,
        utm_medium: utm_medium || null,
        utm_content: utm_content || null,
        utm_term: utm_term || null,
        // Campaign ID (auto-detected)
        campaign_id: detectedCampaignId || null,
        // Google Ads parameters
        gclid: gclid || null,
        gbraid: gbraid || null,
        wbraid: wbraid || null,
        gad_source: gad_source || null,
        gad_campaignid: gad_campaignid || null,
        // Facebook/Meta Ads
        fbclid: fbclid || null,
        fbadid: fbadid || null,
        // TikTok Ads
        ttclid: ttclid || null,
        tt_campaign_id: tt_campaign_id || null,
        // Microsoft/Bing Ads
        msclkid: msclkid || null,
        bing_campaignid: campaignid || CampaignId || null,
        // Twitter/X Ads
        twclid: twclid || null,
        twcamp: twcamp || null,
        // LinkedIn Ads
        li_campaign_id: li_campaign_id || null,
        referrer: typeof document !== "undefined" ? document.referrer : null,
        landing_page: router.asPath,
        timestamp: new Date().toISOString(),
      }

      // Safari with blocked storage (Block All Cookies / Lockdown / private / ITP) throws
      // SecurityError on any sessionStorage access — the typeof guard can't prevent it because
      // the getter itself throws. Persisting attribution is best-effort.
      try {
        sessionStorage.setItem("tracking_data", JSON.stringify(data))
      } catch {
        // storage unavailable — skip persistence
      }

      trackedRef.current = true
    }
  }, [router.query, router.asPath])

  return null
}
